<template>
  <v-container>
    <v-row>
      <v-col cols="10">
        <v-combobox
          v-model="localValue"
          :placeholder="placeholder"
          :label="label"
          :items="items"
          :outlined="outlined"
          :loading="loading"
        />
      </v-col>
      <v-col cols="2">
        <button-with-dialog
          :button-text="'Dodaj'"
          :tooltip-text="'Dodaj tag sensora'"
          :disabledTooltipText="'TEST'"
          :icon="'mdi-plus'"
          :max-width="500"
          ref="add-sensor-tag-dialog-button"
        >
          <template v-slot:body>
            <v-form @submit.prevent="createNewTag">
              <form-base
                title="Zarejestruj tag sensora"
                :submitting="submitting"
                :hide-go-back-button="true"
                @doSubmit="createNewTag"
              >
                <template v-slot:content>
                  <text-field v-model="newSensorTagName" label="Nazwa nowego tagu" />
                  <ul v-if="errors.length > 0" class="errorList">
                    <li v-for="e in errors" :key="e">
                      {{ e }}
                    </li>
                  </ul>
                </template>
              </form-base>
            </v-form>
          </template>
        </button-with-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LocalValueInput from "@/general/component/form/autocomplete/abstract/LocalValueInput";
import AutocompleteProps from "@/general/component/form/autocomplete/abstract/AutocompleteProps";
import {SensorTagApi} from "@/context/sensor/api/SensorTagApi";
import ButtonWithDialog from "@/general/component/button-with-dialog/ButtonWithDialog.vue";
import FormBase from "@/general/abstract/form/FormBase.vue";
import TextField from "@/general/component/TextField.vue";

export default {
  components: {TextField, FormBase, ButtonWithDialog },
  mixins: [LocalValueInput, AutocompleteProps],
  props: {
    value: {
      type: [Number, Object, Array],
      default: null
    },
    preloadAllOptions: {
      type: Boolean,
      default: true
    },
    vid: {
      type: String,
      default: 'Tag sensora'
    },
    label: {
      type: String,
      default: 'Tag sensora'
    },
    placeholder: {
      type: String,
      default: 'Wybierz tag sensora'
    },
    selectedItemToText: {
      type: Function,
      default: item => item.name
    },
    sensorTagListApi: {
      type: Function,
      default: SensorTagApi.findAutocomplete
    },
    outlined: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    async createNewTag() {
      this.submitting = true;
      this.errors = [];
      let response = await SensorTagApi.instance().create({name: this.newSensorTagName});
      if(response.errors) {
        for (const errorKey in response.errors) {
          for (const errorIndex in response.errors[errorKey]) {
            this.errors.push(response.errors[errorKey][errorIndex]);
          }
        }
      } else {
        this.$refs["add-sensor-tag-dialog-button"].closeDialog()
        this.componentKey++;
      }
      this.submitting = false;
    },
    async loadItems(search, queryParam) {
      this.loading = true;
      this.items = await this.sensorTagListApi(search, queryParam);
      this.items = this.items.map((x) => x.name);
      this.loading = false;
    },
  },
  data(){
    return{
      submitting: false,
      newSensorTagName: '',
      errors: [],
      componentKey: 0,
      items: [],
      loading: false
    }
  },
  async mounted() {
    if (this.preloadAllOptions) {
      this.loading = true
      await this.loadItems("", this.queryParam);
      this.loading = false
    } else {
      await this.handleInitialValue();
    }
  },
}
</script>

<style scoped>
.errorList{
  color: darkred;
}
</style>
